function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { EmbeddedRecordsMixin } from '@ember-data/serializer/rest';
import { isNone } from '@ember/utils';
import CatalogObjectSerializer from '@square/dashboard-items-data/serializers/connect/catalog-object';
export default class ItemVariation extends CatalogObjectSerializer.extend(EmbeddedRecordsMixin) {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "attrs", {
      item: {
        serialize: 'id',
        deserialize: 'id',
        serializedOnFragment: 'item_variation_data',
        serializedOnKey: 'item_id'
      },
      intermissions: {
        embedded: 'always',
        serializedOnFragment: 'item_variation_data'
      },
      images: {
        serialize: 'ids',
        deserialize: 'ids',
        serializedOnFragment: 'item_variation_data',
        serializedOnKey: 'image_ids'
      },
      itemVariationVendorInfos: {
        embedded: 'always',
        serializedOnFragment: 'item_variation_data',
        useUnderscoreKey: true
      },
      salePrices: {
        embedded: 'always',
        serializedOnFragment: 'item_variation_data',
        useUnderscoreKey: true
      }
    });
  }
  serialize(snapshot) {
    const json = super.serialize(snapshot, {
      includeId: true
    });
    json.item_variation_data.sale_prices = json.item_variation_data.sale_prices?.filter(sale_price => !isNone(sale_price.sale_price_data.amount_money?.amount));
    return json;
  }
}